// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:56:08.471Z
// Property: Maple Pointe (ID: 6767906449166897)
// Collections: 20 amenities, 5 floorplans (live), 28 photos, 40 POIs, 3 reviews, 3 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166897",
  "property_external_id": "495811",
  "property_zillow_url": "https://www.zillow.com/b/15421-des-moines-memorial-dr-seattle-wa-5gKk3M/",
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Maple+Pointe+Apartments/data=!4m2!3m1!1s0x0:0xd1d3177ded6b6b24?sa=X&ved=2ahUKEwiW9Yvkj7ySAxV8nWoFHZo9EzwQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495811 p0505479",
  "property_status": null,
  "property_slug": "maple-pointe",
  "property_name": "Maple Pointe",
  "property_website_url": "www.burien-apartments.com",
  "property_domain": "https://www.burien-apartments.com/",
  "property_address": "15421 Des Moines Memorial Dr S.",
  "property_full_address": "15421 Des Moines Memorial Dr S., Burien, WA, 98148",
  "property_address_1": "15421 Des Moines Memorial Dr S.",
  "property_address_2": null,
  "property_address_city": "Burien",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98148",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Sunnydale",
  "property_address_latitude": "47.4644",
  "property_address_longitude": "-122.3238",
  "property_email": "maplepointe@ctlmanagement.com",
  "property_phone": "(253) 452-3469",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Maple Pointe in Des Moines, WA, where comfort meets convenience. Our spacious one, two, and three-bedroom apartments offer modern living with premium amenities like a 24-hour fitness center, free tanning, and a swimming pool. Unwind in our clubhouse or enjoy flexible lease terms—your ideal home awaits! Explore availability or schedule a tour today!",
  "property_long_description": "Welcome to Maple Pointe, a vibrant apartment community located in the heart of Des Moines, WA, where comfort meets modern living. Offering thoughtfully designed floor plans, we feature one, two, and three-bedroom apartments perfect for every lifestyle. Each residence comes equipped with a full-size washer and dryer, standard kitchen appliances, and spacious patios or balconies, providing the ideal backdrop for relaxation.\n\nAt Maple Pointe, our extensive amenities cater to your needs and enhance your living experience. Enjoy social gatherings and events in our inviting clubhouse, complete with complimentary Wi-Fi and clubhouse rentals for special occasions. Start your mornings with a fresh cup of coffee from our dedicated coffee bar, and take advantage of our flexible lease terms for hassle-free living.\n\nStay active and healthy with access to our state-of-the-art 24-hour fitness center, a sport court for friendly competition, and a refreshing swimming pool to cool off on warm days. For some well-deserved pampering, indulge in our 24-hour dry sauna and free tanning services.\n\nWith a resident activity program, playground for the little ones, and convenient online rent payments and service requests, life at Maple Pointe is designed for your convenience. Plus, our smoke-free housing and secure 24-hour package lockers ensure a safe and pleasant environment.\n\nDon’t miss out on the perfect place to call home—find your new apartment today! Browse our availability or schedule a tour to explore all that Maple Pointe has to offer. Your ideal living experience awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019db186-6212-7470-bfd9-6f1f57764f42.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
    "public_id": "019db186-6212-7470-bfd9-6f1f57764f42",
    "storage_key": "property/6767906449166897/019db186-6212-7470-bfd9-6f1f57764f42.webp",
    "width": 1920,
    "height": 896
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30 | Deposit $400",
  "property_online_leasing_url": "https://burien-apartments.securecafe.com/onlineleasing/maple-pointe-0/floorplans.aspx",
  "property_resident_portal_url": "https://burien-apartments.securecafe.com/residentservices/maple-pointe-0/userlogin.aspx",
  "property_apply_now_url": "https://burien-apartments.securecafe.com/onlineleasing/maple-pointe-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d73da-fd78-7191-93ed-c561a501cd20.webp",
  "property_primary_logo_media": {
    "alt_text": "Maple Pointe Apartments logo",
    "public_id": "019d73da-fd78-7191-93ed-c561a501cd20",
    "storage_key": "property/6767906449166897/019d73da-fd78-7191-93ed-c561a501cd20.webp",
    "width": 622,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d73da-fe0d-743d-ae4a-0bde3c22ffbc.webp",
  "property_secondary_logo_media": {
    "alt_text": "Maple Pointe Apartments logo",
    "public_id": "019d73da-fe0d-743d-ae4a-0bde3c22ffbc",
    "storage_key": "property/6767906449166897/019d73da-fe0d-743d-ae4a-0bde3c22ffbc.webp",
    "width": 628,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019de0b2-7d6c-75f9-9759-6126164ee9f1.webp",
  "property_mono_white_logo_media": {
    "alt_text": "White space with dark gray bars at top and bottom",
    "public_id": "019de0b2-7d6c-75f9-9759-6126164ee9f1",
    "storage_key": "property/6767906449166897/019de0b2-7d6c-75f9-9759-6126164ee9f1.webp",
    "width": 622,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019de0b2-704f-702e-9999-5199561bcdf4.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Generic industry icon",
    "public_id": "019de0b2-704f-702e-9999-5199561bcdf4",
    "storage_key": "property/6767906449166897/019de0b2-704f-702e-9999-5199561bcdf4.webp",
    "width": 622,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "946 - 946",
  "property_sqft_min": "946",
  "property_sqft_max": "946",
  "property_price_range": "2245 - 2480",
  "property_price_min": "2245",
  "property_price_max": "2480",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/maplepointeapartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJKarG7GBDkFQRJGtr7X0X09E",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/maple-pointe-apartments-burien",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Maple Pointe",
  "property_home_romance_title": "Embrace the Life You Love at Our Charming Apartments ",
  "property_home_amenities_blurb": "Welcome to Maple Pointe in Des Moines, WA, where comfort meets convenience! Choose from our stylish one, two, or three-bedroom apartments, each featuring modern amenities like 24-hour fitness and tanning centers, a refreshing swimming pool, and inviting clubhouse with complimentary Wi-Fi. Experience a vibrant lifestyle today!",
  "property_home_floorplans_blurb": "At Maple Pointe in Des Moines, WA, we offer a distinctive array of apartment homes designed to fit your lifestyle. With thoughtfully crafted floor plans, each residence provides the perfect blend of comfort and style. Browse our available apartments today and uncover the ideal space that feels like home.",
  "property_home_gallery_blurb": "At Maple Pointe in Des Moines, WA, a vibrant lifestyle awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans, and enjoy luxury amenities like a sparkling swimming pool, a 24-hour fitness center, and a cozy coffee bar. Picture yourself living here—where comfort meets convenience!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Des Moines, WA, Maple Pointe offers spacious one, two, and three-bedroom apartments, perfectly situated near vibrant attractions. Enjoy proximity to scenic parks, esteemed colleges, and the awe-inspiring Museum of Flight. Dive into a lifestyle where every convenience beckons, and adventure awaits just outside your door!",
  "property_home_reviews_blurb": "At Maple Pointe in Des Moines, WA, residents rave about their vibrant community, stating, \"Living here feels like being part of a family.\" With spacious apartments and stunning amenities, your perfect home awaits. See what our residents have to say about living at our community and experience the Maple Pointe difference!",
  "property_neighborhood_blurb": "Nestled in the heart of Des Moines, Maple Pointe offers not just a place to live, but an enriching lifestyle. Enjoy proximity to high-quality educational institutions like Highline College and South Seattle College, explore the wonders of The Museum of Flight, or unwind at scenic locales such as Kubota Garden and Seahurst Park.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Maple Pointe in Des Moines, WA, every detail is designed for your lifestyle. Enjoy modern one, two, and three-bedroom floor plans alongside top-notch amenities like a 24-hour fitness center, relaxing dry sauna, and refreshing swimming pool. Experience comfort and convenience—your perfect home awaits.",
  "property_applynow_blurb": "At Maple Pointe in Des Moines, WA, choose from charming one, two, or three-bedroom floor plans designed for modern living. Enjoy exclusive amenities like a 24-hour fitness center, complimentary tanning, and a vibrant resident activity program. Your perfect home awaits—secure your lease online today!",
  "property_contactus_blurb": "At Maple Pointe in Des Moines, WA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Each home blends comfort with style, making every square foot feel inviting. Have questions? Our leasing team is ready to assist—reach out today and find your perfect space!",
  "property_faqs_blurb": "At Maple Pointe in Des Moines, WA, we cater to every lifestyle with our one, two, and three-bedroom floor plans. Our FAQs page offers insights into community living, helping you find the perfect fit. Dive into your future home with confidence—check out the answers to your most pressing questions today!",
  "property_floorplans_blurb": "At Maple Pointe in Des Moines, WA, our thoughtfully designed floor plans cater to every lifestyle. Whether you’re searching for a cozy one-bedroom retreat, a spacious two-bedroom haven, or a family-friendly three-bedroom abode, we have something to suit your needs. Browse our available apartment homes today to find your ideal fit!",
  "property_gallery_blurb": "At Maple Pointe in Des Moines, WA, your dream lifestyle awaits! Picture yourself enjoying our vibrant community: whether you’re unwinding by the pool, savoring a coffee at our bar, or participating in our resident activities. Choose from one, two, or three-bedroom floor plans to fit your unique needs!",
  "property_interactivemap_blurb": "Welcome to Maple Pointe in Des Moines, WA, where modern living meets comfort. Choose from spacious one, two, or three-bedroom layouts, all featuring private patios and in-unit washers. Our vibrant amenities, including a 24-hour fitness center and refreshing swimming pool, cater to your active lifestyle. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Maple Pointe in Des Moines, WA, your furry friends are cherished! Our community embraces indoor adult cats and dogs (up to 25 lbs), ensuring spacious living for you and your pets. Bring home your companions and enjoy life in a welcoming environment tailored for both you and your four-legged family members.",
  "property_referafriend_blurb": "At Maple Pointe in Des Moines, WA, we believe that great friends make great neighbors. With a variety of thoughtfully designed floor plans—one, two, or three bedrooms—there’s a perfect home for everyone. Refer a friend today and embrace the joy of vibrant community living together!",
  "property_residentaccess_blurb": "Welcome to Maple Pointe, your Des Moines haven featuring spacious one, two, and three-bedroom floor plans tailored for comfort. With easy access to your resident portal, managing rent and maintenance requests is a breeze. Log in today and experience the convenience of modern living at your fingertips!",
  "property_reviews_blurb": "At Maple Pointe in Des Moines, WA, our residents rave about the vibrant community atmosphere, saying, \"The neighbors feel like family!\" Experience the warmth and camaraderie that makes living here extraordinary. See what our residents have to say about calling Maple Pointe home!",
  "property_created_at": "1762784952519",
  "property_scheduletour_blurb": "At Maple Pointe in Des Moines, WA, our floor plans cater to every lifestyle, offering cozy one-bedroom retreats to spacious three-bedroom havens. Join our vibrant community—schedule a tour today and discover the heartwarming experiences our residents cherish. Read their stories and envision your new beginning at Maple Pointe!",
  "property_thankyou_blurb": "Thank you for sharing your information with us at Maple Pointe in Des Moines, WA! Our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—offer a perfect home for every lifestyle. Keep an eye on your inbox; our team will be in touch soon to assist you!",
  "property_virtualtours_blurb": "Step into the vibrant lifestyle at Maple Pointe, where modern living meets comfort in Des Moines, WA. With spacious one, two, and three-bedroom floor plans, your ideal home awaits. Experience it all from the comfort of your couch—take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Maple Pointe",
  "property_seo_title_home": "Maple Pointe |  Apartments in Des Moines, WA",
  "property_seo_description_home": "Experience comfort at Maple Pointe in Des Moines, WA. Choose from stylish floor plans, enjoy top-tier amenities, and find your perfect home today!",
  "property_seo_title_floorplans": "Floor Plans | Des Moines, WA Apartments for Rent",
  "property_seo_description_floorplans": "Unveil your ideal space at Maple Pointe in Des Moines, WA! Choose from stylish one, two, or three-bedroom layouts designed for modern living. Browse now!",
  "property_seo_title_amenities": "Amenities | Des Moines, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Maple Pointe in Des Moines, WA. With modern amenities like a fitness center, coffee bar, and pool, your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Des Moines, WA",
  "property_seo_description_gallery": "Experience life at Maple Pointe in Des Moines, WA. From stunning photo galleries to 24/7 amenities, picture your ideal home and vibrant community today!",
  "property_seo_title_virtualtours": "Virtual Tours | Maple Pointe Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Maple Pointe in Des Moines, WA! Take a virtual tour of our inviting one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Maple Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Maple Pointe, Des Moines, WA! Explore one-to-three bedroom apartments and exceptional amenities today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Des Moines, WA",
  "property_seo_description_neighborhood": "Experience the vibrant neighborhood of Maple Pointe in Des Moines, WA. Discover local gems and community favorites just steps from home. Check it out!",
  "property_seo_title_contact": "Contact Us | Maple Pointe",
  "property_seo_description_contact": "Reach out to the Maple Pointe leasing team in Des Moines, WA, for any inquiries on our stylish one, two, and three-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Des Moines, WA",
  "property_seo_description_faqs": "Get answers to all your questions about life at Maple Pointe in Des Moines, WA! Explore amenities, floor plans, and more on our FAQs page today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Des Moines, WA",
  "property_seo_description_reviews": "See what residents love about Maple Pointe in Des Moines, WA! Enjoy vibrant living with top-notch amenities and a welcoming community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Des Moines, WA",
  "property_seo_description_applynow": "Secure your slice of Des Moines at Maple Pointe! Choose from stylish one to three-bedroom apartments with top-notch amenities. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | Maple Pointe",
  "property_seo_description_residentaccess": "Access your Maple Pointe resident portal in Des Moines, WA, to pay rent, schedule maintenance, and enjoy a seamless living experience at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Maple Pointe",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Maple Pointe in Des Moines, WA, and enjoy life in a vibrant community together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Maple Pointe",
  "property_seo_description_scheduletour": "Experience the charm of Maple Pointe in Des Moines, WA. Schedule your tour today and explore stylish apartments and vibrant community life!",
  "property_seo_title_privacy": "Privacy Policy | Maple Pointe",
  "property_seo_description_privacy": "At Maple Pointe in Des Moines, WA, your privacy matters. Learn how we protect your personal information with our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Maple Pointe",
  "property_seo_description_accessibility": "At Maple Pointe in Des Moines, WA, we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can connect and thrive here.",
  "property_seo_title_sitemap": "Sitemap | Maple Pointe",
  "property_seo_description_sitemap": "Uncover the highlights of Maple Pointe in Des Moines, WA. Navigate our sitemap to find your future home and all the community amenities you’ll love!",
  "property_seo_title_thankyou": "Thank You | Maple Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Maple Pointe! Our team will connect soon to guide you to your new home in beautiful Des Moines, WA. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Burien, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874964557",
  "amenities": [
    {
      "id": "ec_ad3724c029a9e8352ffebd0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429034",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-2796-766f-822e-6d3fc6c54266.webp",
      "amenity_image_media": {
        "alt_text": "Cozy community lounge with a fireplace, comfortable seating, and a dining area.",
        "public_id": "019d1c01-2796-766f-822e-6d3fc6c54266",
        "storage_key": "property/6767906449166897/019d1c01-2796-766f-822e-6d3fc6c54266.webp",
        "width": 1024,
        "height": 660
      },
      "amenity_image_alt_text": "Maple Pointe Clubhouse Interior Seating Area & Fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec262c01c870cdaaac7e317f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429035",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-2778-712d-bb76-bf473d97bd21.webp",
      "amenity_image_media": {
        "alt_text": "Gym with weight machines, treadmills, and elliptical trainers.",
        "public_id": "019d1c01-2778-712d-bb76-bf473d97bd21",
        "storage_key": "property/6767906449166897/019d1c01-2778-712d-bb76-bf473d97bd21.webp",
        "width": 1024,
        "height": 677
      },
      "amenity_image_alt_text": "Maple Pointe Fitness Center & Equipment,Maple Pointe Fitness Center Cardio Equipment",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9381b7317f13f6764efbdbe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429032",
      "title": "24-Hour Dry Sauna",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-277b-741e-a5df-4292bb26d844.webp",
      "amenity_image_media": {
        "alt_text": "Interior of a wooden sauna with benches and a heater.",
        "public_id": "019d1c01-277b-741e-a5df-4292bb26d844",
        "storage_key": "property/6767906449166897/019d1c01-277b-741e-a5df-4292bb26d844.webp",
        "width": 1024,
        "height": 678
      },
      "amenity_image_alt_text": "Maple Pointe Dry Sauna",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2f7f90c9250b28098ea82fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429040",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-278c-724d-a10b-6e84ab976445.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d1c01-278c-724d-a10b-6e84ab976445",
        "storage_key": "property/6767906449166897/019d1c01-278c-724d-a10b-6e84ab976445.webp",
        "width": 1024,
        "height": 612
      },
      "amenity_image_alt_text": "Maple Pointe Pool & Sundeck,Maple Pointe Apartments Pool & Lounge Chairs,Maple Pointe Apartments Pool with Chaise Lounges",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b551a60db95c4d79f6a2c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429038",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3dc4-72af-ad72-63222d30b5d6.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
        "public_id": "019d1c01-3dc4-72af-ad72-63222d30b5d6",
        "storage_key": "property/6767906449166897/019d1c01-3dc4-72af-ad72-63222d30b5d6.webp",
        "width": 1024,
        "height": 678
      },
      "amenity_image_alt_text": "Maple Pointe Playground",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b23ad04b99bb0e3962f23b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "86393083",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0971709bbbb390b3de436d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429033",
      "title": "24-Hour Free Tanning",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-277b-741e-a5df-3c6a060dd169.webp",
      "amenity_image_media": {
        "alt_text": "Red tanning bed with blue lights",
        "public_id": "019d1c01-277b-741e-a5df-3c6a060dd169",
        "storage_key": "property/6767906449166897/019d1c01-277b-741e-a5df-3c6a060dd169.webp",
        "width": 1024,
        "height": 678
      },
      "amenity_image_alt_text": "Maple Pointe Tanning Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86f8be0146b128b23ac96ec0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429039",
      "title": "Sport Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3d03-756a-b5b6-3374176a05fc.webp",
      "amenity_image_media": {
        "alt_text": "Basketball court with a pool and apartment buildings in the background.",
        "public_id": "019d1c01-3d03-756a-b5b6-3374176a05fc",
        "storage_key": "property/6767906449166897/019d1c01-3d03-756a-b5b6-3374176a05fc.webp",
        "width": 1024,
        "height": 678
      },
      "amenity_image_alt_text": "Maple Pointe Basketball Court",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47aea8e52b93cb2914dc3c5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "120558554",
      "title": "Self-Service Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_daf4b0d9b1b088a265a17836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "86393081",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-278d-71dd-8c38-0d7e3754d59f.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace and seating areas",
        "public_id": "019d1c01-278d-71dd-8c38-0d7e3754d59f",
        "storage_key": "property/6767906449166897/019d1c01-278d-71dd-8c38-0d7e3754d59f.webp",
        "width": 1024,
        "height": 664
      },
      "amenity_image_alt_text": "Maple Pointe Clubhouse Interior Seating Area & Fireplace,Maple Pointe Clubhouse Interior Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbc27076dc39044f81772d50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429037",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e172284777c0e4d6c1b2a989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "82390178",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad835cf059d5bd6ece366b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "82390179",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf8e6f8b8740241bc2eb5b73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "86393086",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e701cead7da702dbfe33d52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429042",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4ece-73a3-a646-5730490ab151.webp",
      "amenity_image_media": {
        "alt_text": "In-unit washer and dryer with overhead shelf and adjoining bathroom.",
        "public_id": "019d1c01-4ece-73a3-a646-5730490ab151",
        "storage_key": "property/6767906449166897/019d1c01-4ece-73a3-a646-5730490ab151.webp",
        "width": 1144,
        "height": 781
      },
      "amenity_image_alt_text": "Maple Pointe Vacant Apartment Washer & Dryer & Bathroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4badb05a6c60f7d2a6dfc847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429041",
      "title": "Woodburning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4b5a-7067-aea8-5e50fdf869de.webp",
      "amenity_image_media": {
        "alt_text": "Spacious living room with a brick fireplace and a sliding glass door.",
        "public_id": "019d1c01-4b5a-7067-aea8-5e50fdf869de",
        "storage_key": "property/6767906449166897/019d1c01-4b5a-7067-aea8-5e50fdf869de.webp",
        "width": 1182,
        "height": 767
      },
      "amenity_image_alt_text": "Maple Pointe Vacant Apartment Living Room & Fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f94b42403cdebfe8d9303d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429043",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-5603-765a-98fc-c49f4a9e8308.webp",
      "amenity_image_media": {
        "alt_text": "Balcony overlooking trees and blue sky.",
        "public_id": "019d1c01-5603-765a-98fc-c49f4a9e8308",
        "storage_key": "property/6767906449166897/019d1c01-5603-765a-98fc-c49f4a9e8308.webp",
        "width": 1170,
        "height": 783
      },
      "amenity_image_alt_text": "Maple Pointe Vacant Apartment Deck",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28525dbac7164f795e8e2d95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429045",
      "title": "Attached Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3422833e1bbf30ace304176b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "80429044",
      "title": "Standard Kitchen Appliances Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4c7e-7509-9d89-35ecbf76f6f0.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dark wood cabinets, black appliances including a refrigerator and stove, and granite countertops.",
        "public_id": "019d1c01-4c7e-7509-9d89-35ecbf76f6f0",
        "storage_key": "property/6767906449166897/019d1c01-4c7e-7509-9d89-35ecbf76f6f0.webp",
        "width": 1136,
        "height": 759
      },
      "amenity_image_alt_text": "Maple Pointe Vacant Apartment Upgraded Kitchen & BVar",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0831c2198d3975d39290888a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "yardi",
      "external_id": "87310438",
      "title": "Pool View - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-278c-724d-a10b-6e84ab976445.webp",
      "amenity_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d1c01-278c-724d-a10b-6e84ab976445",
        "storage_key": "property/6767906449166897/019d1c01-278c-724d-a10b-6e84ab976445.webp",
        "width": 1024,
        "height": 612
      },
      "amenity_image_alt_text": "Maple Pointe Pool & Sundeck",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_77b4ab1f46117096a98ce28f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-27c7-75cc-9f59-bb5bc10bdf18.webp",
      "image_media": {
        "alt_text": "Maple Pointe Apartment Homes entrance monument sign with address and phone number.",
        "public_id": "019d1c01-27c7-75cc-9f59-bb5bc10bdf18",
        "storage_key": "property/6767906449166897/019d1c01-27c7-75cc-9f59-bb5bc10bdf18.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Community",
      "description": "Welcome to Maple Pointe Apartment Homes. Visit us at 5421 Des Moines Memorial Dr. or call 206-241-0310.",
      "link": "false",
      "alt_text": "Maple Pointe Apartment Homes entrance monument sign with address and phone number.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_Monument01.jpg"
    },
    {
      "id": "ec_2264bfd13407f0193b04b468",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-27c4-77a5-be55-2cc713d543e3.webp",
      "image_media": {
        "alt_text": "Leasing office entrance with signage and outdoor pergola.",
        "public_id": "019d1c01-27c4-77a5-be55-2cc713d543e3",
        "storage_key": "property/6767906449166897/019d1c01-27c4-77a5-be55-2cc713d543e3.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Community",
      "description": "Welcome to our leasing office! Beautifully landscaped entrance with a welcoming pergola and exterior signage.",
      "link": "false",
      "alt_text": "Leasing office entrance with signage and outdoor pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_ClubhouseExterior01.jpg"
    },
    {
      "id": "ec_ee4a3f3de55683d968e7445d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-2796-766f-822e-6d3fc6c54266.webp",
      "image_media": {
        "alt_text": "Cozy community lounge with a fireplace, comfortable seating, and a dining area.",
        "public_id": "019d1c01-2796-766f-822e-6d3fc6c54266",
        "storage_key": "property/6767906449166897/019d1c01-2796-766f-822e-6d3fc6c54266.webp",
        "width": 1024,
        "height": 660
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring a warm fireplace, plush seating, and a convenient dining space for residents.",
      "link": "false",
      "alt_text": "Cozy community lounge with a fireplace, comfortable seating, and a dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_ClubhouseInterior01.jpg"
    },
    {
      "id": "ec_04ae84e2db39a5f534ac9c55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-278d-71dd-8c38-0d7e3754d59f.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and seating areas",
        "public_id": "019d1c01-278d-71dd-8c38-0d7e3754d59f",
        "storage_key": "property/6767906449166897/019d1c01-278d-71dd-8c38-0d7e3754d59f.webp",
        "width": 1024,
        "height": 664
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable leather sofas, and a TV entertainment center, perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with fireplace and seating areas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_ClubhouseInterior02.jpg"
    },
    {
      "id": "ec_a1d3590e515f703f86847718",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-277c-74ee-9a37-e813c1b3eda9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry",
        "public_id": "019d1c01-277c-74ee-9a37-e813c1b3eda9",
        "storage_key": "property/6767906449166897/019d1c01-277c-74ee-9a37-e813c1b3eda9.webp",
        "width": 1024,
        "height": 671
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring wood cabinets, stainless steel appliances, and a breakfast bar. Ideal for everyday cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and wood cabinetry",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_ClubhouseInterior03.jpg"
    },
    {
      "id": "ec_2e3b1f28a5e29df3e9f0b57f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-2778-712d-bb76-bf473d97bd21.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, and elliptical trainers.",
        "public_id": "019d1c01-2778-712d-bb76-bf473d97bd21",
        "storage_key": "property/6767906449166897/019d1c01-2778-712d-bb76-bf473d97bd21.webp",
        "width": 1024,
        "height": 677
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with a variety of cardio and strength training equipment for your workout needs.",
      "link": "false",
      "alt_text": "Gym with weight machines, treadmills, and elliptical trainers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_FitnessCenter01.jpg"
    },
    {
      "id": "ec_7ab84817dc169aed33e05d0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-27c1-7778-809c-cb0c2cedbabc.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a well-lit gym",
        "public_id": "019d1c01-27c1-7778-809c-cb0c2cedbabc",
        "storage_key": "property/6767906449166897/019d1c01-27c1-7778-809c-cb0c2cedbabc.webp",
        "width": 1024,
        "height": 679
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully equipped fitness center, featuring cardio machines and free weights.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machines in a well-lit gym",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_FitnessCenter02.jpg"
    },
    {
      "id": "ec_064b7e63d972cb327b64badc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-277b-741e-a5df-3c6a060dd169.webp",
      "image_media": {
        "alt_text": "Red tanning bed with blue lights",
        "public_id": "019d1c01-277b-741e-a5df-3c6a060dd169",
        "storage_key": "property/6767906449166897/019d1c01-277b-741e-a5df-3c6a060dd169.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Other",
      "description": "This image shows a red tanning bed with blue lights, often found in gyms or spas. It is a common amenity in some apartment communities.",
      "link": "false",
      "alt_text": "Red tanning bed with blue lights",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_TanningRoom.jpg"
    },
    {
      "id": "ec_387b1305615544575556c2e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-277b-741e-a5df-4292bb26d844.webp",
      "image_media": {
        "alt_text": "Interior of a wooden sauna with benches and a heater.",
        "public_id": "019d1c01-277b-741e-a5df-4292bb26d844",
        "storage_key": "property/6767906449166897/019d1c01-277b-741e-a5df-4292bb26d844.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Community",
      "description": "Relax and rejuvenate in the community sauna, featuring natural wood finishes and a powerful heater for the ultimate spa experience.",
      "link": "false",
      "alt_text": "Interior of a wooden sauna with benches and a heater.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_DrySauna.jpg"
    },
    {
      "id": "ec_d28533a282a81de793f7c5ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-278c-724d-a10b-6e84ab976445.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d1c01-278c-724d-a10b-6e84ab976445",
        "storage_key": "property/6767906449166897/019d1c01-278c-724d-a10b-6e84ab976445.webp",
        "width": 1024,
        "height": 612
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_Pool01.jpg"
    },
    {
      "id": "ec_bfcc5df244738b96cd995d64",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3ced-762c-9d9b-95c749a20713.webp",
      "image_media": {
        "alt_text": "Community pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019d1c01-3ced-762c-9d9b-95c749a20713",
        "storage_key": "property/6767906449166897/019d1c01-3ced-762c-9d9b-95c749a20713.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on warm days.",
      "link": "false",
      "alt_text": "Community pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_Pool02.jpg"
    },
    {
      "id": "ec_596c999c0d7aab912997aebd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3c63-7635-b22e-c1ffe6f1483d.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and palm trees.",
        "public_id": "019d1c01-3c63-7635-b22e-c1ffe6f1483d",
        "storage_key": "property/6767906449166897/019d1c01-3c63-7635-b22e-c1ffe6f1483d.webp",
        "width": 1024,
        "height": 649
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "Bright blue swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_Pool03.jpg"
    },
    {
      "id": "ec_2d7eb90be135b65a3eab7727",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3dc7-707b-9043-3b88372543dd.webp",
      "image_media": {
        "alt_text": "Apartment complex with playground and swimming pool.",
        "public_id": "019d1c01-3dc7-707b-9043-3b88372543dd",
        "storage_key": "property/6767906449166897/019d1c01-3dc7-707b-9043-3b88372543dd.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Community",
      "description": "Enjoy outdoor living at this apartment complex, featuring a playground for children and a refreshing swimming pool for residents.",
      "link": "false",
      "alt_text": "Apartment complex with playground and swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_PlaygroundPool.jpg"
    },
    {
      "id": "ec_386ab88845948e9c94843adb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3dc4-72af-ad72-63222d30b5d6.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
        "public_id": "019d1c01-3dc4-72af-ad72-63222d30b5d6",
        "storage_key": "property/6767906449166897/019d1c01-3dc4-72af-ad72-63222d30b5d6.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures perfect for family enjoyment.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_Playground.jpg"
    },
    {
      "id": "ec_4816b4f292bac2f1a2e091d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3d03-756a-b5b6-3374176a05fc.webp",
      "image_media": {
        "alt_text": "Basketball court with a pool and apartment buildings in the background.",
        "public_id": "019d1c01-3d03-756a-b5b6-3374176a05fc",
        "storage_key": "property/6767906449166897/019d1c01-3d03-756a-b5b6-3374176a05fc.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our full-sized basketball court, conveniently located near the community pool and lounge area.",
      "link": "false",
      "alt_text": "Basketball court with a pool and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_BasketballCourt.jpg"
    },
    {
      "id": "ec_eafba18a0e25fc6fb58be56b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-3ee0-740b-b92d-f236851db852.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with manicured bushes and green lawn.",
        "public_id": "019d1c01-3ee0-740b-b92d-f236851db852",
        "storage_key": "property/6767906449166897/019d1c01-3ee0-740b-b92d-f236851db852.webp",
        "width": 1024,
        "height": 686
      },
      "title": "Community",
      "description": "Showcasing the attractive exterior of the apartment complex, featuring well-maintained landscaping and building architecture.",
      "link": "false",
      "alt_text": "Exterior view of the apartment building with manicured bushes and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_BuildingExterior.jpg"
    },
    {
      "id": "ec_2657e1e6b130f72a9cabda64",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-44d9-7678-b5b8-6c8ba0fb9197.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, black appliances, and a large window.",
        "public_id": "019d1c01-44d9-7678-b5b8-6c8ba0fb9197",
        "storage_key": "property/6767906449166897/019d1c01-44d9-7678-b5b8-6c8ba0fb9197.webp",
        "width": 1169,
        "height": 782
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring dark wood cabinetry, granite countertops, and black appliances, perfect for preparing meals. A large window offers views of greenery.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, black appliances, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantUpgradedKitchen01.jpg"
    },
    {
      "id": "ec_f304e74292dd09496d19686b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4c7e-7509-9d89-35ecbf76f6f0.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, black appliances including a refrigerator and stove, and granite countertops.",
        "public_id": "019d1c01-4c7e-7509-9d89-35ecbf76f6f0",
        "storage_key": "property/6767906449166897/019d1c01-4c7e-7509-9d89-35ecbf76f6f0.webp",
        "width": 1136,
        "height": 759
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring dark wood cabinetry, granite countertops, and modern black appliances, including a refrigerator and stove.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, black appliances including a refrigerator and stove, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantUpgradedKitchen02.jpg"
    },
    {
      "id": "ec_d5e773cad3f27b5bec9fe408",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-46cd-7448-96bd-380c3be03e01.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with fireplace and sliding glass doors.",
        "public_id": "019d1c01-46cd-7448-96bd-380c3be03e01",
        "storage_key": "property/6767906449166897/019d1c01-46cd-7448-96bd-380c3be03e01.webp",
        "width": 1166,
        "height": 782
      },
      "title": "Apartment",
      "description": "Enjoy ample living space with a cozy fireplace and access to outdoor areas. The open kitchen design includes a breakfast bar for casual dining.",
      "link": "false",
      "alt_text": "Spacious living room and kitchen area with fireplace and sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantDiningRoom.jpg"
    },
    {
      "id": "ec_a64b5074d2f4d10f4a5ef613",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4b5a-7067-aea8-5e50fdf869de.webp",
      "image_media": {
        "alt_text": "Spacious living room with a brick fireplace and a sliding glass door.",
        "public_id": "019d1c01-4b5a-7067-aea8-5e50fdf869de",
        "storage_key": "property/6767906449166897/019d1c01-4b5a-7067-aea8-5e50fdf869de.webp",
        "width": 1182,
        "height": 767
      },
      "title": "Apartment",
      "description": "Cozy up by the fireplace in this spacious living area. Features a charming brick fireplace and a sliding glass door for easy access to outdoor space.",
      "link": "false",
      "alt_text": "Spacious living room with a brick fireplace and a sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantFireplace.jpg"
    },
    {
      "id": "ec_27c205471a01afe697a7b28d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4ab2-75ec-bbf2-35471019f240.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass door to balcony and view of trees.",
        "public_id": "019d1c01-4ab2-75ec-bbf2-35471019f240",
        "storage_key": "property/6767906449166897/019d1c01-4ab2-75ec-bbf2-35471019f240.webp",
        "width": 1182,
        "height": 765
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, a sliding glass door providing access to a balcony, and an adjacent dining area. Enjoy comfortable living in this beautifully appointed apartment.",
      "link": "false",
      "alt_text": "Living room with sliding glass door to balcony and view of trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantLivingRoom01.jpg"
    },
    {
      "id": "ec_74689924107659d51b9078ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4e83-70f6-9733-068325039502.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sliding glass door leading to balcony",
        "public_id": "019d1c01-4e83-70f6-9733-068325039502",
        "storage_key": "property/6767906449166897/019d1c01-4e83-70f6-9733-068325039502.webp",
        "width": 1182,
        "height": 783
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace and a sliding glass door for access to outdoor space. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with fireplace and sliding glass door leading to balcony",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantLivingRoom02.jpg"
    },
    {
      "id": "ec_bd4116f5c8dd068d93aa1ac9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4ece-73a3-a646-5730490ab151.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with overhead shelf and adjoining bathroom.",
        "public_id": "019d1c01-4ece-73a3-a646-5730490ab151",
        "storage_key": "property/6767906449166897/019d1c01-4ece-73a3-a646-5730490ab151.webp",
        "width": 1144,
        "height": 781
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer with a shelf for storage, plus an adjacent bathroom with vanity and toilet.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with overhead shelf and adjoining bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantLaundry.jpg"
    },
    {
      "id": "ec_b58742eb667c5a5023c9c561",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-4c41-755a-9ac3-10cbd31b49fd.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a bathtub, toilet, and vanity with a sink and mirror.",
        "public_id": "019d1c01-4c41-755a-9ac3-10cbd31b49fd",
        "storage_key": "property/6767906449166897/019d1c01-4c41-755a-9ac3-10cbd31b49fd.webp",
        "width": 1024,
        "height": 678
      },
      "title": "Apartment",
      "description": "A well-maintained bathroom featuring a bathtub, toilet, and a vanity with a sink and ample storage space behind the mirror.",
      "link": "false",
      "alt_text": "Clean bathroom with a bathtub, toilet, and vanity with a sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_VacantUpgradedBathroom.jpg"
    },
    {
      "id": "ec_7963953a2db03622cec88c27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-5603-765a-98fc-c49f4a9e8308.webp",
      "image_media": {
        "alt_text": "Balcony overlooking trees and blue sky.",
        "public_id": "019d1c01-5603-765a-98fc-c49f4a9e8308",
        "storage_key": "property/6767906449166897/019d1c01-5603-765a-98fc-c49f4a9e8308.webp",
        "width": 1170,
        "height": 783
      },
      "title": "Apartment",
      "description": "Enjoy fresh air and scenic views from your private balcony, a perfect extension of your living space.",
      "link": "false",
      "alt_text": "Balcony overlooking trees and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_Patio.jpg"
    },
    {
      "id": "ec_ada0fff4aa4aad85ebc55d07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-55a1-766a-bc17-e8c69a38ebc9.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, a white stove, stainless steel sink, and a window overlooking greenery.",
        "public_id": "019d1c01-55a1-766a-bc17-e8c69a38ebc9",
        "storage_key": "property/6767906449166897/019d1c01-55a1-766a-bc17-e8c69a38ebc9.webp",
        "width": 958,
        "height": 612
      },
      "title": "Apartment",
      "description": "This apartment kitchen features ample wooden cabinetry, a full-sized stove, and a bright window with a view of lush trees. It's the perfect space for culinary creation.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, a white stove, stainless steel sink, and a window overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_WA_NonUpgradedKitchen01.jpg"
    },
    {
      "id": "ec_d041ab370bce4c891e29759f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-59de-72f9-9c80-cbe73fee6934.webp",
      "image_media": {
        "alt_text": "Kitchen with refrigerator, sink, dishwasher, and wooden cabinets.",
        "public_id": "019d1c01-59de-72f9-9c80-cbe73fee6934",
        "storage_key": "property/6767906449166897/019d1c01-59de-72f9-9c80-cbe73fee6934.webp",
        "width": 800,
        "height": 554
      },
      "title": "Apartment",
      "description": "A functional and cozy kitchen featuring a refrigerator, a double basin sink with a window view, and ample cabinet space. Perfect for your culinary adventures.",
      "link": "false",
      "alt_text": "Kitchen with refrigerator, sink, dishwasher, and wooden cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_NonUpgradedKitchen02.jpg"
    },
    {
      "id": "ec_3ea5a2a61d4c80e94645cae2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d1c01-5928-7358-a47c-8ffe5813c5cf.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and bathtub",
        "public_id": "019d1c01-5928-7358-a47c-8ffe5813c5cf",
        "storage_key": "property/6767906449166897/019d1c01-5928-7358-a47c-8ffe5813c5cf.webp",
        "width": 800,
        "height": 561
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a wooden vanity with a sink, a toilet, and a bathtub with towels. Candles and a small plant add decorative touches.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, toilet, and bathtub",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/MaplePointe_Burien_NonUpgradedBathroom.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_75c4a821-327f-4934-bdcc-262450f0f1a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Topgolf",
      "poi_type": "Restaurants",
      "poi_address": "780 Logan Ave N, Renton, WA 98057, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun and unique golfing experience with a variety of games, as well as tasty food and drinks, including chicken strips, tots, and donut holes. They also highlight the friendly and helpful staff, the clean and comfortable atmosphere, and the reasonable prices, especially during off-peak hours.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-9efe-7749-925e-a123508d4fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-9efe-7749-925e-a123508d4fe7",
        "storage_key": "property/6767906449166897/019d08ae-9efe-7749-925e-a123508d4fe7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/renton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17862906076997390043&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf",
      "poi_latitude": "47.4949267",
      "poi_longitude": "-122.2063361",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-517-0695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45c4-76ae-8b8d-2b3157e56052",
        "storage_key": "property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5TFdg5pkFQR246Yb2_K5fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5c6842b3-db65-40b8-8dc9-78a7b881c92d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Feast Buffet",
      "poi_type": "Restaurants",
      "poi_address": "485 Renton Center Way SW, Renton, WA 98057, USA",
      "poi_short_description": "Spacious, contemporary restaurant offering all-you-can-eat Asian fare from dim sum to sushi.",
      "poi_long_description": "People say this buffet restaurant offers a huge variety of seafood, including lobster, crab legs, and oysters, as well as sushi, dim sum, and Mongolian stir fry. They also highlight the fresh food, the extensive dessert bar with options like creme brulee and cotton candy, and the good value, especially during lunch.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-9e4c-73b9-a42d-ad6a51a2a836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-9e4c-73b9-a42d-ad6a51a2a836",
        "storage_key": "property/6767906449166897/019d08ae-9e4c-73b9-a42d-ad6a51a2a836.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.feastbuffetrenton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3396167711752454497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feast-buffet",
      "poi_latitude": "47.4765227",
      "poi_longitude": "-122.2177215",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-235-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45c4-76ae-8b8d-2b3157e56052",
        "storage_key": "property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvdObvbJCkFQRYQGoSIqcIS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_0c4284ca-578a-42bc-9d84-5a1e2b4a80dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "17333 Southcenter Pkwy, Tukwila, WA 98188, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches. They also highlight the friendly staff, fast service, and clean dining area with a play area.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-9f05-7229-8355-0af764be657e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-9f05-7229-8355-0af764be657e",
        "storage_key": "property/6767906449166897/019d08ae-9f05-7229-8355-0af764be657e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/southcenter-parkway?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12040570452370729501&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.4479051",
      "poi_longitude": "-122.2631615",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-575-7547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45c4-76ae-8b8d-2b3157e56052",
        "storage_key": "property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYi7o3ldkFQRHSqfYgizGKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3f3e643f-59f7-4def-a036-fb91237cb900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "13 Coins SeaTac",
      "poi_type": "Restaurants",
      "poi_address": "18000 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "Funky eatery serving Italian & American dishes, with high-backed booths & bar seating.",
      "poi_long_description": "People say this restaurant serves delicious chicken parmesan, prime rib, and French onion soup. They also highlight the comfortable booths, the convenient location near the airport, and the friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-9f39-7725-b3d1-e892dadc7e39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-9f39-7725-b3d1-e892dadc7e39",
        "storage_key": "property/6767906449166897/019d08ae-9f39-7725-b3d1-e892dadc7e39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.13coins.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2627747442472948407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "13-coins-seatac",
      "poi_latitude": "47.44124900000001",
      "poi_longitude": "-122.295415",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-243-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45c4-76ae-8b8d-2b3157e56052",
        "storage_key": "property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzbIw6ahckFQRt5IKZGCidyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_74574667-ad96-4c2f-aeb7-bbf443c8d394",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Din Tai Fung 鼎泰豐",
      "poi_type": "Restaurants",
      "poi_address": "181 Southcenter Mall, Tukwila, WA 98188, USA",
      "poi_short_description": "Casual, spacious dumpling house for lunch and dinner with Taiwanese options, cocktails, beer and wine.",
      "poi_long_description": "People say this Chinese restaurant serves delicious soup dumplings, green beans, and spicy wontons. They highlight the quick service, friendly staff, and clean atmosphere. They also like the extensive menu with vegetarian options and the tasty cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-a8f0-74ce-88ce-4dfaa5aa71f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-a8f0-74ce-88ce-4dfaa5aa71f9",
        "storage_key": "property/6767906449166897/019d08ae-a8f0-74ce-88ce-4dfaa5aa71f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dtf.com/us/locations/tukwila.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15945595886352380482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung-",
      "poi_latitude": "47.4584359",
      "poi_longitude": "-122.2608666",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-257-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45c4-76ae-8b8d-2b3157e56052",
        "storage_key": "property/6767906449166897/019d08ae-45c4-76ae-8b8d-2b3157e56052.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJodnGp9NckFQRQrL2qfkiSt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_e703eef3-11e8-485c-a069-4519d8829bd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Westfield Southcenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2800 Southcenter Mall, Seattle, WA 98188, USA",
      "poi_short_description": "2-level indoor shopping mall with more than 200 stores & eateries plus a multiplex with IMAX.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, restaurants, and a movie theater. They also highlight the friendly staff, the fun and enjoyable shopping experience, and the convenient parking.\n\nSome reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-a8cb-704f-a5b9-0c5fc23c4d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-a8cb-704f-a5b9-0c5fc23c4d81",
        "storage_key": "property/6767906449166897/019d08ae-a8cb-704f-a5b9-0c5fc23c4d81.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/southcenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=7722388109786479024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-southcenter",
      "poi_latitude": "47.4588849",
      "poi_longitude": "-122.257964",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-246-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-4b12-7628-9515-c7f7969e3631.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4b12-7628-9515-c7f7969e3631",
        "storage_key": "property/6767906449166897/019d08ae-4b12-7628-9515-c7f7969e3631.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1W80hNNckFQRsPmFJRJvK2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a2ee9dca-9116-4a3d-a9c7-37aedbb12daa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "601 SW 41st St, Renton, WA 98057, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide selection of high-quality furniture and home decor. They also highlight the affordable prices, friendly and helpful staff, and easy returns.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-a8cb-704f-a5b9-00ce048b7793.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-a8cb-704f-a5b9-00ce048b7793",
        "storage_key": "property/6767906449166897/019d08ae-a8cb-704f-a5b9-00ce048b7793.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/renton/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=renton",
      "poi_directions_map_url": "https://maps.google.com/?cid=14843228672508442262&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "47.4424006",
      "poi_longitude": "-122.2285737",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-4b12-7628-9515-c7f7969e3631.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4b12-7628-9515-c7f7969e3631",
        "storage_key": "property/6767906449166897/019d08ae-4b12-7628-9515-c7f7969e3631.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu15VQR1dkFQRljbCuNW9_c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_f962873b-b2d6-459b-8def-e485d4a0315c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "21100 91st Pl S, Kent, WA 98031, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of groceries, including fresh produce, meat, and bulk items, at affordable prices. They also highlight the friendly staff, convenient 24-hour service, and ample parking.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-aa2f-72dd-bfee-2e7295589fa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-aa2f-72dd-bfee-2e7295589fa9",
        "storage_key": "property/6767906449166897/019d08ae-aa2f-72dd-bfee-2e7295589fa9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7441409303228944828&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "47.4146395",
      "poi_longitude": "-122.2190107",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-850-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-4b06-71db-be23-878add92d04a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4b06-71db-be23-878add92d04a",
        "storage_key": "property/6767906449166897/019d08ae-4b06-71db-be23-878add92d04a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRR5LkFckFQRvJE_w1UyRWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_108361bf-e0a4-48b6-b621-06870d3aecbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "99 Ranch Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "18230 E Valley Hwy #100, Kent, WA 98032, USA",
      "poi_short_description": "Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh seafood, vegetables, and other Asian foods, including canned goods, meat, and bakery items. They also highlight the reasonable prices, especially with discounts, and the friendly staff.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.99ranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3413166522718048566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "99-ranch-market",
      "poi_latitude": "47.4387751",
      "poi_longitude": "-122.2209003",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-251-9099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-4b06-71db-be23-878add92d04a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4b06-71db-be23-878add92d04a",
        "storage_key": "property/6767906449166897/019d08ae-4b06-71db-be23-878add92d04a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYS68mwJdkFQRNlHdYd4AXi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_e6f97ef3-3d96-498a-9f6d-d5981901283e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "15868 1st Ave S, Burien, WA 98148, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of unique and exotic foods, including organic and gluten-free options, as well as fresh produce. They highlight the affordable prices and the friendly, helpful staff. They also like the easy parking and quick checkout lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ad-daff-710e-952a-bc62733aa1c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-daff-710e-952a-bc62733aa1c5",
        "storage_key": "property/6767906449166897/019d08ad-daff-710e-952a-bc62733aa1c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/burien/133/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6274973072331786337&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.460074",
      "poi_longitude": "-122.3313909",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-901-9339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-4b06-71db-be23-878add92d04a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-4b06-71db-be23-878add92d04a",
        "storage_key": "property/6767906449166897/019d08ae-4b06-71db-be23-878add92d04a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaytCap9EkFQRYUh6V8MuFVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_326ef950-0ee8-4efd-a2b0-22ac11ff27be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Highline College",
      "poi_type": "Education",
      "poi_address": "2400 S 240th St, Des Moines, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ad-f5bc-749b-a28e-319a551543a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f5bc-749b-a28e-319a551543a4",
        "storage_key": "property/6767906449166897/019d08ad-f5bc-749b-a28e-319a551543a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.highline.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9102534943473461902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "highline-college",
      "poi_latitude": "47.38833469999999",
      "poi_longitude": "-122.3017666",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-878-3710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-507b-73c8-ac55-4e27a2c549bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-507b-73c8-ac55-4e27a2c549bc",
        "storage_key": "property/6767906449166897/019d08ae-507b-73c8-ac55-4e27a2c549bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0oT_BNDkFQRjupQxU2zUn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d2614161-c812-427d-9195-d7c69d6d257a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "South Seattle College",
      "poi_type": "Education",
      "poi_address": "6000 16th Ave SW, Seattle, WA 98106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-b1d7-7761-aab1-2e2760c8012e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-b1d7-7761-aab1-2e2760c8012e",
        "storage_key": "property/6767906449166897/019d08ae-b1d7-7761-aab1-2e2760c8012e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.southseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13605236372797138528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-seattle-college",
      "poi_latitude": "47.54804379999999",
      "poi_longitude": "-122.3524481",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-934-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-507b-73c8-ac55-4e27a2c549bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-507b-73c8-ac55-4e27a2c549bc",
        "storage_key": "property/6767906449166897/019d08ae-507b-73c8-ac55-4e27a2c549bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE6VQHKRBkFQRYCbMvWWCz7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5200b4b6-6866-484c-9846-2264b2822895",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "The Museum of Flight",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98108, USA",
      "poi_short_description": "Large educational museum with aircraft & space vehicles on display, plus historical exhibits.",
      "poi_long_description": "People say this museum offers a vast collection of aircraft, including a Boeing 747, Concorde, and Space Shuttle, as well as interactive exhibits and flight simulators. They highlight the museum is family-friendly, educational, and worth the price of admission, especially with a membership. They also like the knowledgeable staff and the opportunity to walk through some of the aircraft.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-b1d8-743e-9659-38d9f9946734.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-b1d8-743e-9659-38d9f9946734",
        "storage_key": "property/6767906449166897/019d08ae-b1d8-743e-9659-38d9f9946734.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.museumofflight.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=118380609308048042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-museum-of-flight",
      "poi_latitude": "47.5185379",
      "poi_longitude": "-122.2968545",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-764-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-f5be-7589-8f69-feb70e578da7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-f5be-7589-8f69-feb70e578da7",
        "storage_key": "property/6767906449166897/019d08ae-f5be-7589-8f69-feb70e578da7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxVwIjlCkFQRqroZdomSpAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_66ee94c1-173b-4da9-aa71-a7b5cad8b7cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Henry Moses Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "1719 Maple Vly Hwy, Renton, WA 98057, USA",
      "poi_short_description": "Kids-friendly water park featuring a wave pool, a lazy river and slides and a heated pool.",
      "poi_long_description": "People say this water park offers a wave pool, lazy river, and slides. They also highlight the clean facilities, attentive staff, and fun atmosphere, especially for families with kids.\n\nOther reviews mention the tickets can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-b382-75d6-ae0d-d59f1b8f5790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-b382-75d6-ae0d-d59f1b8f5790",
        "storage_key": "property/6767906449166897/019d08ae-b382-75d6-ae0d-d59f1b8f5790.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rentonwa.gov/Government/Departments-and-Offices/Parks-and-Recreation/Things-To-Do/Henry-Moses-Aquatic-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=313983733861091180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-moses-aquatic-center",
      "poi_latitude": "47.4817697",
      "poi_longitude": "-122.1949815",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-430-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5qPmf5nkFQRbIcK2op-WwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_a4e27bd3-69de-4faf-a6ea-5e6f35bf697b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Renton Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "405 Logan Ave N, Renton, WA 98057, USA",
      "poi_short_description": "Stadium featuring football games, soccer matches and track meets.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-b39a-76ac-bbaf-838d16b9fcdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-b39a-76ac-bbaf-838d16b9fcdb",
        "storage_key": "property/6767906449166897/019d08ae-b39a-76ac-bbaf-838d16b9fcdb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://rentonhs.rentonschools.us/athletics/renton-memorial-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=9465353700824293072&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renton-memorial-stadium",
      "poi_latitude": "47.4886768",
      "poi_longitude": "-122.2095896",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-204-2423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-f5c0-70cb-90bb-0ce032d9b2d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-f5c0-70cb-90bb-0ce032d9b2d9",
        "storage_key": "property/6767906449166897/019d08ae-f5c0-70cb-90bb-0ce032d9b2d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG22ZAqhCkFQR0J4PkwqxW4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_47cb11b1-c5fa-4133-b458-a847abc99aa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Georgetown Steam Plant",
      "poi_type": "Entertainment",
      "poi_address": "6605 13th Ave S, Seattle, WA 98108, USA",
      "poi_short_description": "Large, former power plant dating back to 1906 offering guided tours of its inner workings.",
      "poi_long_description": "Large, former power plant dating back to 1906 offering guided tours of its inner workings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-bfe0-77d6-b897-8a5041b5d9ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-bfe0-77d6-b897-8a5041b5d9ac",
        "storage_key": "property/6767906449166897/019d08ae-bfe0-77d6-b897-8a5041b5d9ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.georgetownsteamplant.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6105686170413575995&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgetown-steam-plant",
      "poi_latitude": "47.5428094",
      "poi_longitude": "-122.3162428",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-763-2542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-f5be-7589-8f69-feb70e578da7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-f5be-7589-8f69-feb70e578da7",
        "storage_key": "property/6767906449166897/019d08ae-f5be-7589-8f69-feb70e578da7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_-PUe1BkFQROy-EATnBu1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a535519a-21cc-48a2-b605-ddde68d5b14e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Starfire Sports Stadium - Field 1",
      "poi_type": "Entertainment",
      "poi_address": "14800 Starfire Way, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-bfdd-72ad-84c3-c06cb31551c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-bfdd-72ad-84c3-c06cb31551c5",
        "storage_key": "property/6767906449166897/019d08ae-bfdd-72ad-84c3-c06cb31551c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4088469378211575441&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "starfire-sports-stadium---field-1",
      "poi_latitude": "47.4698415",
      "poi_longitude": "-122.2471764",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-f5c0-70cb-90bb-0ce032d9b2d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-f5c0-70cb-90bb-0ce032d9b2d9",
        "storage_key": "property/6767906449166897/019d08ae-f5c0-70cb-90bb-0ce032d9b2d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAftKNtJCkFQRkfZc4zwpvTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_36f82257-b6df-4aab-ad6c-10b924293569",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "14905 4th Ave SW, Burien, WA 98166, USA",
      "poi_short_description": "Chain gym offering an array of cardio equipment, weights, group classes and a pool.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, a pool, and a basketball court, and the staff is friendly and helpful.\n\nOther reviews mention the equipment can be poorly maintained and the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-c9d9-708f-a49c-217a2e43825b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-c9d9-708f-a49c-217a2e43825b",
        "storage_key": "property/6767906449166897/019d08ae-c9d9-708f-a49c-217a2e43825b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1048&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5296242190726727845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.469461",
      "poi_longitude": "-122.3411593",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-701-3446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL36q2oJEkFQRpQi0NjYIgEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d98c7478-0d98-4782-a699-b24d29139fd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "18129 E Valley Hwy, Kent, WA 98032, USA",
      "poi_short_description": "Members-only gym chain offering equipment, tanning, and spa services, plus a welcoming, nonjudgmental environment.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including machines, tanning beds, and massage machines. They also highlight the friendly, helpful, and welcoming staff, and the clean, spacious, and well-organized facility.\n\nOther reviews mention the temperature can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-bf39-71d6-b327-c3ad556a1c57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-bf39-71d6-b327-c3ad556a1c57",
        "storage_key": "property/6767906449166897/019d08ae-bf39-71d6-b327-c3ad556a1c57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/kent-kent-valley-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16425903657210620319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.4396504",
      "poi_longitude": "-122.2223068",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-243-6009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-HvGNxdkFQRnynUGlmI9OM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cb10f31a-a63f-457c-af13-d0a69f6d0228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Matt Griffin YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3595 S 188th St, SeaTac, WA 98188, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Visitors say this gym has a great pool with warm, clean water and excellent swim instructors. They also highlight the spacious layout, solid equipment, and friendly atmosphere.\n\nSome reviews mention the pool can be frequently closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-1c12-77dd-a673-3ae5b30f825e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1c12-77dd-a673-3ae5b30f825e",
        "storage_key": "property/6767906449166897/019d08ae-1c12-77dd-a673-3ae5b30f825e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattleymca.org/locations/matt-griffin-ymca?utm_source=google&utm_medium=organic&utm_campaign=business-listing&utm_content=matt-griffin",
      "poi_directions_map_url": "https://maps.google.com/?cid=4772808112517058483&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "matt-griffin-ymca",
      "poi_latitude": "47.4337385",
      "poi_longitude": "-122.2882906",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-244-5880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5n-BKFckFQRs4-u37BrPEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dd558785-337b-4957-a248-261991dd750a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "17320 Southcenter Pkwy, Tukwila, WA 98188, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-c9da-775a-aa1a-6813fcdf179a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-c9da-775a-aa1a-6813fcdf179a",
        "storage_key": "property/6767906449166897/019d08ae-c9da-775a-aa1a-6813fcdf179a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tukwila-wa-191",
      "poi_directions_map_url": "https://maps.google.com/?cid=15091536541923712576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "47.448395",
      "poi_longitude": "-122.2611342",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-575-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5TsiXVdkFQRQJ4wyIbob9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_8f643400-885b-482e-9fa0-4d1247f68ed2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Metropolitan Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6822 S 190th St, Kent, WA 98032, USA",
      "poi_short_description": "Toddler-friendly gymnastics center providing classes and competitive team opportunities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-cbf1-76c8-82aa-c3dc075b0af9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-cbf1-76c8-82aa-c3dc075b0af9",
        "storage_key": "property/6767906449166897/019d08ae-cbf1-76c8-82aa-c3dc075b0af9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://metropolitangym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093236913196072024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metropolitan-gymnastics",
      "poi_latitude": "47.4328435",
      "poi_longitude": "-122.2477764",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-282-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-507b-73c8-ac55-4e27a2c549bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-507b-73c8-ac55-4e27a2c549bc",
        "storage_key": "property/6767906449166897/019d08ae-507b-73c8-ac55-4e27a2c549bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnWcqiO1ckFQRWHz1x_zPrkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cc48c5b2-e470-4461-a133-921d0f012b51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "402 Baker Blvd, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-cf2f-727f-85c9-2853645678a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-cf2f-727f-85c9-2853645678a1",
        "storage_key": "property/6767906449166897/019d08ae-cf2f-727f-85c9-2853645678a1.webp",
        "width": 816,
        "height": 460
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/renton-wa/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16364207143402972431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "47.458721",
      "poi_longitude": "-122.252096",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-496-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcS3WPR1dkFQRD6VxFbJXGeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e442d2b9-1de8-498b-8af7-d2a63d3949ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "400 S 43rd St, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-d093-726a-ba84-0e7f27c2d722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-d093-726a-ba84-0e7f27c2d722",
        "storage_key": "property/6767906449166897/019d08ae-d093-726a-ba84-0e7f27c2d722.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "http://www.valleymed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6634061436974118693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "valley-medical-center",
      "poi_latitude": "47.4428037",
      "poi_longitude": "-122.2138885",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-690-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-50bb-7245-af8c-9f10dba66b4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-50bb-7245-af8c-9f10dba66b4e",
        "storage_key": "property/6767906449166897/019d08ae-50bb-7245-af8c-9f10dba66b4e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS9badNqkFQRJbf1aLrrEFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_97712f0b-5dff-4a33-859b-3d3a92d5c87e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "St. Anne Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "16251 Sylvester Rd SW, Burien, WA 98166, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-0db0-7338-abac-37542d80f672.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0db0-7338-abac-37542d80f672",
        "storage_key": "property/6767906449166897/019d08ae-0db0-7338-abac-37542d80f672.webp",
        "width": 1209,
        "height": 640
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/st-anne-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=10014091768260235562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-anne-hospital",
      "poi_latitude": "47.4573951",
      "poi_longitude": "-122.3425954",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-244-9970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-50bb-7245-af8c-9f10dba66b4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-50bb-7245-af8c-9f10dba66b4e",
        "storage_key": "property/6767906449166897/019d08ae-50bb-7245-af8c-9f10dba66b4e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01Ir55dEkFQRKpFQA2gz-Yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5f85edd4-9393-4e1e-9412-7e1c48ed4894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Lincoln Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8011 Fauntleroy Wy SW, Seattle, WA 98136, USA",
      "poi_short_description": "Rocky coastline adorned with playgrounds, BBQs, hiking & biking trails & a heated saltwater pool.",
      "poi_long_description": "People say this park offers beautiful trails, a beach, a playground, ball fields, and an outdoor pool. They highlight the scenic views, the peaceful and serene atmosphere, and the opportunity to see wildlife, including seals and whales. They also like the clean restrooms and the friendly people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-dbb0-718a-b882-41f84045dcca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-dbb0-718a-b882-41f84045dcca",
        "storage_key": "property/6767906449166897/019d08ae-dbb0-718a-b882-41f84045dcca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/lincoln-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16686431432944069629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lincoln-park",
      "poi_latitude": "47.53057099999999",
      "poi_longitude": "-122.395992",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-5085-76cb-bbea-a4d51623fd86",
        "storage_key": "property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRb12DlBkFQR_SuL0fockuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c1c2f2cf-8b37-487e-9f0e-ee307a48d909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Kubota Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9817 55th Ave S, Seattle, WA 98118, USA",
      "poi_short_description": "Hilly 20-acre Japanese-style garden dating to 1927, with flowers, ponds, waterfalls & a moon bridge.",
      "poi_long_description": "Visitors say this Japanese garden offers peaceful walking paths, stunning views, and a tranquil atmosphere, perfect for relaxing or enjoying nature. They also highlight the well-maintained grounds, diverse plant life, and abundance of benches for sitting and enjoying the surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-db73-7536-abcd-8cb70362bd63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-db73-7536-abcd-8cb70362bd63",
        "storage_key": "property/6767906449166897/019d08ae-db73-7536-abcd-8cb70362bd63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kubotagarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16083961869648009774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kubota-garden",
      "poi_latitude": "47.5134676",
      "poi_longitude": "-122.2658737",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-725-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-5085-76cb-bbea-a4d51623fd86",
        "storage_key": "property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2y97GVCkFQRLhpMnRq2Nd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_197f2f96-1cd8-4cc5-a48e-ff471e953626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Seahurst Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 SW Seahurst Park Rd, Burien, WA 98166, USA",
      "poi_short_description": "Scenic Puget Sound beach offering picnicking, forest trails & ample photo opportunities.",
      "poi_long_description": "People say this park offers beautiful forested trails, a restored beach, and stunning views of Puget Sound and the Olympic Mountains. They highlight the peaceful and refreshing vibe, and the family-friendly atmosphere with picnic areas, a playground, and ample open space. They also like the clean facilities, including restrooms and dog waste disposal stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-df5f-739e-8699-6797480b8680.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-df5f-739e-8699-6797480b8680",
        "storage_key": "property/6767906449166897/019d08ae-df5f-739e-8699-6797480b8680.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://burienwa.gov/residents/parks_recreation_cultural_services/city_parks_trails_facilities/seahurst_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18197522955814146684&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seahurst-park",
      "poi_latitude": "47.4762175",
      "poi_longitude": "-122.3602348",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-988-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-5085-76cb-bbea-a4d51623fd86",
        "storage_key": "property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbgYQHlEkFQRfJJRtbaWivw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f1391e41-cd1d-420f-8535-3708a6d67fb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Saltwater State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "25205 8th Pl S, Des Moines, WA 98198, USA",
      "poi_short_description": "This park on the shores of Puget Sound has campsites, volleyball courts & an artificial reef.",
      "poi_long_description": "People say this state park offers a beautiful beach, hiking trails, and opportunities to explore sea life at low tide. They highlight the peaceful and relaxing vibe, and the availability of amenities such as picnic tables, restrooms, and a playground. They also like the ample parking and the option to bring dogs on leash.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-0633-7419-8c29-9d197f566bba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0633-7419-8c29-9d197f566bba",
        "storage_key": "property/6767906449166897/019d08ae-0633-7419-8c29-9d197f566bba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://parks.state.wa.us/578/Saltwater",
      "poi_directions_map_url": "https://maps.google.com/?cid=6985291121296586622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saltwater-state-park",
      "poi_latitude": "47.3758089",
      "poi_longitude": "-122.3231043",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-661-4956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-5085-76cb-bbea-a4d51623fd86",
        "storage_key": "property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36mzLDlakFQRfreS4UO98GA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_c961aa21-5503-4917-a83c-4dc8f8f8be12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Angle Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19408 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "This green space with a lake offers amenities such as a boat launch, playground & water spray park.",
      "poi_long_description": "People say this park offers a lake for swimming, fishing, and boating, as well as a splash pad, playground, and picnic areas. They highlight the beautiful lake views, the ample grassy areas for playing and relaxing, and the availability of lifeguards during the summer. They also like the paved walkways, the easy beach access, and the presence of wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-2363-754a-9faa-5b5a64fb8fbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2363-754a-9faa-5b5a64fb8fbc",
        "storage_key": "property/6767906449166897/019d08ae-2363-754a-9faa-5b5a64fb8fbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seatacwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10463006071752659881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "angle-lake-park",
      "poi_latitude": "47.428313",
      "poi_longitude": "-122.294627",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-973-4680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-5085-76cb-bbea-a4d51623fd86",
        "storage_key": "property/6767906449166897/019d08ae-5085-76cb-bbea-a4d51623fd86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7NCsWBbkFQRqZOSPZYQNJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4af87bec-c86f-4562-b0eb-5a6310eddc2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Seattle–Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-3251-7639-b72e-2aec8bcb25d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3251-7639-b72e-2aec8bcb25d1",
        "storage_key": "property/6767906449166897/019d08ae-3251-7639-b72e-2aec8bcb25d1.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattletacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-787-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-57cc-70ff-a7fd-baa225bd8c6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-57cc-70ff-a7fd-baa225bd8c6a",
        "storage_key": "property/6767906449166897/019d08ae-57cc-70ff-a7fd-baa225bd8c6a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_9b1c507d-5fd3-4d8e-801d-8d1f5c8aaa3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Tukwila Int'l Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "3651 Southcenter Blvd, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-2fec-7143-9bd8-f9be08d93874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-2fec-7143-9bd8-f9be08d93874",
        "storage_key": "property/6767906449166897/019d08ae-2fec-7143-9bd8-f9be08d93874.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/tukwila-international-boulevard-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=3918699620542677033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tukwila-intl-blvd",
      "poi_latitude": "47.4640995",
      "poi_longitude": "-122.2882273",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XkFKzhDkFQRKYDn74oEYjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_029accd9-0e22-4946-8064-4728fa91cdfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "King County International Airport - Boeing Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7277 Perimeter Rd S, Seattle, WA 98108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-3d1b-75da-8cbc-aea984af87f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-3d1b-75da-8cbc-aea984af87f0",
        "storage_key": "property/6767906449166897/019d08ae-3d1b-75da-8cbc-aea984af87f0.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "http://www.kingcounty.gov/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635828346216693482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "king-county-international-airport---boeing-field",
      "poi_latitude": "47.5369043",
      "poi_longitude": "-122.3038555",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-296-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-57cc-70ff-a7fd-baa225bd8c6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-57cc-70ff-a7fd-baa225bd8c6a",
        "storage_key": "property/6767906449166897/019d08ae-57cc-70ff-a7fd-baa225bd8c6a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_--ofVBkFQR6r7ut1HFVUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_bd9a0ff6-7721-4e0b-a3ad-7e87d268af0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Tukwila",
      "poi_type": "Transportation & Transit",
      "poi_address": "7301 Longacres Way, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-31ff-76cf-890b-7aea2a50b1a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-31ff-76cf-890b-7aea2a50b1a8",
        "storage_key": "property/6767906449166897/019d08ae-31ff-76cf-890b-7aea2a50b1a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TUK",
      "poi_directions_map_url": "https://maps.google.com/?cid=7463838225028263000&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tukwila",
      "poi_latitude": "47.460666",
      "poi_longitude": "-122.2405258",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-57c9-734b-975d-2909eb043580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-57c9-734b-975d-2909eb043580",
        "storage_key": "property/6767906449166897/019d08ae-57c9-734b-975d-2909eb043580.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcZcuC5dkFQRWKzKD1LhlGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_45967c6c-57d3-491e-b91c-be9ddd3e4d50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Angle Lake",
      "poi_type": "Transportation & Transit",
      "poi_address": "SeaTac, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-e4d4-732e-98a9-f76bce4ece39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-e4d4-732e-98a9-f76bce4ece39",
        "storage_key": "property/6767906449166897/019d08ae-e4d4-732e-98a9-f76bce4ece39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15554939121471465518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "angle-lake",
      "poi_latitude": "47.4223163",
      "poi_longitude": "-122.2978013",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSKHS29bkFQRLigiprc-3tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_74e81156-9006-468f-bdb8-dafb20dbbddb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Boeing 10-20",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 N 6th St, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-e5e9-73db-93e7-342d18beb5d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-e5e9-73db-93e7-342d18beb5d2",
        "storage_key": "property/6767906449166897/019d08ae-e5e9-73db-93e7-342d18beb5d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356682190396930037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boeing-10-20",
      "poi_latitude": "47.49249",
      "poi_longitude": "-122.204694",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TDm1DBpkFQR9TdxMy3m-HM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3e3fc70a-360f-4a79-b81a-3b175e9426cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "FAA Bldg",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 S 216th St, Des Moines, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-e644-7026-ba35-74ebc2b88646.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-e644-7026-ba35-74ebc2b88646",
        "storage_key": "property/6767906449166897/019d08ae-e644-7026-ba35-74ebc2b88646.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.faa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523186749664561825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "faa-bldg",
      "poi_latitude": "47.4093889",
      "poi_longitude": "-122.3054526",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-231-3828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzNAhgxbkFQRoYryrJO7Qgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_be14c251-5839-434d-9689-093e1540f296",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Renton City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1055 S Grady Way, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-e894-709e-bf86-9bca857dbb2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-e894-709e-bf86-9bca857dbb2e",
        "storage_key": "property/6767906449166897/019d08ae-e894-709e-bf86-9bca857dbb2e.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://rentonwa.gov/city_hall",
      "poi_directions_map_url": "https://maps.google.com/?cid=1274733248939844054&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renton-city-hall",
      "poi_latitude": "47.4747631",
      "poi_longitude": "-122.2047575",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-430-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-5ecc-7766-9902-2b2c0f65f247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-5ecc-7766-9902-2b2c0f65f247",
        "storage_key": "property/6767906449166897/019d08ae-5ecc-7766-9902-2b2c0f65f247.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITiwwVNdkFQR1mFw1iLDsBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_dd00ef0a-25fd-4cfe-a0ee-1e6ac41ea07a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Darigold",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5601 6th Ave S #300, Seattle, WA 98108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-ed65-74b2-956c-e48b0eafb096.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-ed65-74b2-956c-e48b0eafb096",
        "storage_key": "property/6767906449166897/019d08ae-ed65-74b2-956c-e48b0eafb096.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.darigold.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12448908645738258870&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "darigold",
      "poi_latitude": "47.5522581",
      "poi_longitude": "-122.3278192",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-216-4283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNaJr221qkFQRtqGExnRow6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c54f4ad6-7585-470c-8e5d-7be76fb55a47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "poi_name": "Triton Towers Two",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 S Renton Village Pl, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-ed76-75aa-a91f-0e41341caf9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-ed76-75aa-a91f-0e41341caf9e",
        "storage_key": "property/6767906449166897/019d08ae-ed76-75aa-a91f-0e41341caf9e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tritontowers.com/toc.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12168192566078800015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "triton-towers-two",
      "poi_latitude": "47.4701144",
      "poi_longitude": "-122.2089485",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-45cd-710f-9675-df28a3fc959a",
        "storage_key": "property/6767906449166897/019d08ae-45cd-710f-9675-df28a3fc959a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQ9ZT05dkFQRjwCtQ6sa3qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_15111f3856f4f178f82c0c41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_36ee6bac294b55ee69e4cf1e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_6777ad4682ec1d9c9aa4d599",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_810dd481485e13b4065a1e14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_0c44a292f5ecd215c3e674b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_5055acb6e97b8509cd6ec76e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "13:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7972c91a-7901-46a2-b953-f66a56d4a17e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "rating": "5.0",
      "name": "Mathewos B Chali",
      "text": "I recently signed a lease to staying at Maple Point Apartments in Burien, and I can’t say enough good things about my experience. From the moment I arrived, the atmosphere was welcoming and comfortable. The apartment itself was clean, spacious, and well-maintained, with modern amenities that will make my stay enjoyable.\n\nWhat truly set this experience apart was the outstanding management by “Kodey”. He was incredibly responsive, friendly and attentive, always available to address any questions or concerns. “Kodey” went above and beyond to ensure that all residents felt at home.\n\nThe location is another plus, with easy access to local shops, parks, and public transport. I highly recommend Maple Point Apartments for anyone looking for a great place to live in Burien. Thanks to “Kodey” and the entire team for making my apartment search and leasing easy!",
      "date": "2024-09-18",
      "title": ""
    },
    {
      "id": "custom_6b544df8-8fe2-4e0e-90c0-bdd0ee152290",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "rating": "5.0",
      "name": "samiullah hamidi",
      "text": "I am so happy that we could finally find a place to call home (Maple Point Apartments).\nWe are so thankful to management team at this complex specially Kody and Tracy whom made the whole process so easy and quick for us to move in. They are so reliable and responsive for any issue and would help at their best.\nThank you so much Kody.",
      "date": "2024-08-25",
      "title": ""
    },
    {
      "id": "custom_b20deef7-c4e2-4ccf-8f52-27f8163a467b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "rating": "5.0",
      "name": "mark hall",
      "text": "Very nice, freshly renovated apartment.   The application process and move was seamless thanks to Cody (property manager) and team.  We had a simple maintenance issue and it was handled and resolved within 24 hours.   We couldn’t be more happy with our new apartment home.",
      "date": "2019-05-03",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b05f800b-5ef8-458e-9148-2b8e818cf2c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d2c22-fc4c-71dd-8c12-810e431a55b1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c22-fc4c-71dd-8c12-810e431a55b1",
        "storage_key": "property/6767906449166897/019d2c22-fc4c-71dd-8c12-810e431a55b1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Maple Pointe Apartments - 1 Bedroom 1 Bath 666 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5jpP7ipCgra"
    },
    {
      "id": "custom_43292dfa-9b82-4d84-8a73-a854d99139d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d2c23-158e-771e-a098-30a42b6494fb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c23-158e-771e-a098-30a42b6494fb",
        "storage_key": "property/6767906449166897/019d2c23-158e-771e-a098-30a42b6494fb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Maple Pointe Apartments - 2 Bedroom 2 Bath 946 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8gRKkKNtckk"
    },
    {
      "id": "custom_374e873b-b608-430d-81a6-32201ab33ce8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166897/019d2c23-3224-70ef-89ad-bbf522c14c0f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c23-3224-70ef-89ad-bbf522c14c0f",
        "storage_key": "property/6767906449166897/019d2c23-3224-70ef-89ad-bbf522c14c0f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Maple Pointe Apartments - Clubhouse, Fitness Center & Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qZPzwb9YxGX"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a9-ec72-7218-ad62-f43eddd20a74",
      "lead_source": "LANDING_PAGE",
      "name": "Maple Pointe Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897"
    },
    {
      "lead_collector_id": "019db1aa-1db6-77a6-a767-42e658c4f884",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Maple Pointe Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-swimming-pool-des-moines-wa",
      "search_query": "apartments with swimming pool Des Moines WA",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool - Des Moines, WA",
      "h2_subtitle": "Discover Maple Pointe's refreshing swimming pool. Enjoy relaxation and fun at our Des Moines, WA community with a spectacular aquatic feature.",
      "page_copy": "At Maple Pointe, tranquility meets luxury in Des Moines, WA. Our apartment community offers a pristine swimming pool perfect for unwinding and enjoying a sunny afternoon. Nestled in the charming neighborhood of Sunnydale, residents can dive into leisure or recline poolside to soak in the serene environment.\n\nBeyond the pool, Maple Pointe boasts an array of amenities including a sport court, private patios and balconies, and a fully equipped 24-hour dry sauna. Experience the best of apartment living where every convenience is designed to enhance your lifestyle. Join us and see why Maple Pointe is the ideal choice for those seeking apartments with swimming pool Des Moines WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool in Des Moines, WA",
      "seo_description": "Explore Maple Pointe, offering a pristine swimming pool and more in Des Moines, WA. Perfect for relaxation and fun.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-sunnydale",
      "search_query": "in unit laundry apartments Sunnydale",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Sunnydale",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Maple Pointe. Located in Sunnydale, our apartments offer ease and comfort to suit your lifestyle.",
      "page_copy": "Experience the modern convenience of in-unit laundry at Maple Pointe, situated in the vibrant neighborhood of Sunnydale. No more laundry room trips or waiting for machines—our apartments bring the luxury of doing laundry in the comfort of your own space. Located in Des Moines, WA, Maple Pointe ensures that daily tasks become seamless and hassle-free.\n\nOur community not only offers in-unit laundry facilities but also a range of premium amenities including a sparkling swimming pool, sport court, and 24-hour free tanning. With private patios and balconies, you're guaranteed a lifestyle that blends relaxation and convenience. Choose Maple Pointe for your next home and enjoy all that Sunnydale has to offer for in-unit laundry apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments | Sunnydale",
      "seo_description": "Enjoy in-unit laundry at Maple Pointe in Sunnydale. Experience modern amenities in Des Moines, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "pet-friendly-fitness-center-king-county",
      "search_query": "pet friendly 24-hour fitness center King County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with 24-Hour Fitness",
      "h2_subtitle": "Maple Pointe offers pet-friendly living with a 24-hour fitness center. Located in King County, enjoy exercise access anytime while keeping pets close.",
      "page_copy": "Maple Pointe in Des Moines, WA combines pet-friendly living with top-notch amenities like a 24-hour fitness center. Residing in King County, our community ensures both you and your furry companions feel at home. With access to a fitness center any time of day, you can tailor your workout schedule to suit your lifestyle while having the comfort of your pet close by.\n\nLocated in the inviting Sunnydale neighborhood, Maple Pointe also provides a range of desirable features including a sport court, swimming pool, and in-unit laundry. Our community is crafted for those who appreciate flexibility, convenience, and a welcoming environment for both residents and pets alike. Discover the advantages of living at Maple Pointe, where well-being and accessibility take center stage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly & 24-Hour Fitness | King County",
      "seo_description": "At Maple Pointe, enjoy pet-friendly living and a 24-hour fitness center in King County, Des Moines, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "smoke-free-flexible-leases-des-moines-wa",
      "search_query": "Des Moines WA smoke free housing with flexible leases",
      "category": "Amenity",
      "h1_title": "Smoke-Free Housing with Flexible Leases",
      "h2_subtitle": "Maple Pointe offers smoke-free living in Des Moines, WA. Enjoy the flexibility of adjustable leases that cater to your unique lifestyle needs.",
      "page_copy": "Welcome to Maple Pointe, where smoke-free housing meets the flexibility you need in Des Moines, WA. Our community prioritizes a clean and healthy living environment by adhering to a strict smoke-free policy, ensuring comfort and well-being for all residents. Located in the desirable Sunnydale neighborhood, we cater to individuals seeking adaptable living solutions.\n\nAt Maple Pointe, we understand that life changes require accommodations, which is why we offer flexible leasing options. This allows you to select lease terms that best fit your lifestyle. Our expansive amenities, including a sport court, swimming pool, and 24-hour sauna, complement the convenience of personalized lease terms, making Maple Pointe an ideal choice for those who value both flexibility and a smoke-free setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Housing & Flexible Leases | Des Moines, WA",
      "seo_description": "Discover smoke-free living with flexible leases at Maple Pointe in Des Moines, WA. Enjoy customizable terms with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-patio-balcony-des-moines-98148",
      "search_query": "apartments with patio balcony Des Moines 98148",
      "category": "Amenity",
      "h1_title": "Apartments with Patio/Balcony in Des Moines",
      "h2_subtitle": "Enjoy outdoor living with patio or balcony options at Maple Pointe, nestled in Des Moines, 98148. Experience the beauty of King County from your home.",
      "page_copy": "Maple Pointe offers a refreshing take on apartment living with spacious patios and balconies, allowing residents to bask in the natural beauty of Des Moines, 98148. Our thoughtfully designed spaces provide the perfect outdoor escape right at your doorstep, making it easy to unwind and soak in the serene scenery of King County.\n\nBeyond the appealing patios and balconies, Maple Pointe features an array of amenities designed for a balanced lifestyle. Residents can enjoy a stunning swimming pool, sport court, and benefit from our 24-hour free tanning and sauna facilities. Located in the inviting Sunnydale neighborhood, our apartments offer the perfect blend of outdoor enjoyment and convenience in Des Moines. Your next home at Maple Pointe awaits, where patio and balcony living is at its best.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Patio/Balcony | Des Moines 98148",
      "seo_description": "Relax on patios and balconies at Maple Pointe in Des Moines 98148. Explore outdoor living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-des-moines-wa",
      "search_query": "one bedroom apartments in Des Moines WA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Des Moines, WA",
      "h2_subtitle": "Explore one bedroom apartments at Maple Pointe, Des Moines. Enjoy spacious living in our welcoming community situated in the heart of King County.",
      "page_copy": "Discover one bedroom apartments at Maple Pointe, ideally located in Des Moines, WA. Our well-designed units offer a perfect balance of comfort and style, providing a welcoming atmosphere for individuals or couples seeking quality living spaces. Situated in the tranquil Sunnydale neighborhood, our community boasts accessibility and charm in the heart of King County.\n\nAt Maple Pointe, residents benefit from premium amenities such as a refreshing swimming pool, sport court, and easy access to a 24-hour dry sauna and tanning facilities. Enjoy the convenience of modern living along with the flexibility of various lease options. Maple Pointe's one bedroom apartments are perfect for those prioritizing space, convenience, and a vibrant community environment in Des Moines.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Des Moines, WA",
      "seo_description": "Discover Maple Pointe's one bedroom apartments in Des Moines, WA. Ideal for modern and comfortable living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-king-county",
      "search_query": "two bedroom apartments King County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in King County",
      "h2_subtitle": "Discover spacious two bedroom apartments at Maple Pointe in the heart of King County. Perfect for families or roommates seeking modern amenities.",
      "page_copy": "Welcome to Maple Pointe, where spacious two bedroom apartments in King County provide an ideal setting for families, couples, or roommates. Each unit is designed to offer ample living space, comfort, and contemporary style, ensuring that every household member enjoys privacy and convenience. Nestled in the friendly Sunnydale neighborhood of Des Moines, our community is a sought-after destination for those seeking quality living.\n\nMaple Pointe not only offers large living spaces but also a wide range of amenities including a swimming pool, sport court, and 24-hour access to both a dry sauna and free tanning services. Our property is conveniently located, providing easy access to local attractions and services in King County. Choose Maple Pointe for your next home and enjoy the benefits of spacious two bedroom living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments | King County, WA",
      "seo_description": "Find perfect two bedroom apartments with Maple Pointe in King County, offering modern amenities in a comfortable setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-des-moines-98148",
      "search_query": "three bedroom apartments 98148",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedroom Apartments in 98148",
      "h2_subtitle": "Explore three bedroom apartments at Maple Pointe in Des Moines, WA. Perfect for families needing space and premium amenities.",
      "page_copy": "Experience the ample space and modern comfort of three bedroom apartments at Maple Pointe in Des Moines, WA, 98148. These apartments offer the perfect layout for families or roommates, providing room for everyone with the added luxury of a community nestled in the beautiful setting of King County. Located in the inviting Sunnydale neighborhood, our community is designed with both convenience and elegance in mind.\n\nMaple Pointe enhances everyday living with top-tier amenities such as a sparkling swimming pool, a well-maintained sport court, and 24-hour access to both a dry sauna and free tanning facilities. Each three bedroom apartment is crafted to maximize comfort and utility, offering residents a premium living experience in the heart of Des Moines. Make Maple Pointe your home and enjoy the benefits of a spacious and supportive community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 98148",
      "seo_description": "Discover spacious three bedroom apartments in Des Moines, 98148, at Maple Pointe. Perfect for families with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-near-highline-college-des-moines",
      "search_query": "apartments near Highline College Des Moines",
      "category": "School",
      "h1_title": "Apartments Near Highline College, Des Moines",
      "h2_subtitle": "Discover apartments conveniently located near Highline College at Maple Pointe. Perfect for students and staff seeking modern living close to campus.",
      "page_copy": "Maple Pointe offers the ideal accommodation for those seeking apartments near Highline College in Des Moines. Our prime location provides easy access to the college, making it an excellent option for both students and staff. Situated in the vibrant Sunnydale neighborhood, our community combines the tranquility of suburban living with the convenience of proximity to educational facilities and local services.\n\nAt Maple Pointe, you'll enjoy amenities like a refreshing swimming pool, a welcoming sport court, and access to a 24-hour dry sauna and tanning services. Our spacious units offer comfortable living with modern designs that are both functional and stylish. Whether you're studying, working, or both, Maple Pointe provides a supportive and enriching environment for college life in Des Moines, WA. Choose Maple Pointe for a blend of convenience and quality living near Highline College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Highline College, Des Moines, WA",
      "seo_description": "Find your home at Maple Pointe, ideally located near Highline College in Des Moines. Perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "maple-pointe-near-south-seattle-college",
      "search_query": "Maple Pointe apartments close to South Seattle College King County",
      "category": "School",
      "h1_title": "Maple Pointe: Close to South Seattle College",
      "h2_subtitle": "Discover how Maple Pointe offers the perfect location near South Seattle College in King County. Ideal for students and faculty alike.",
      "page_copy": "Located in the heart of King County, Maple Pointe provides the ideal setting for those seeking apartments close to South Seattle College. Our community not only offers convenient access to the college but also an array of amenities that enrich the living experience. Whether you're a student or faculty member, Maple Pointe offers a welcoming and conducive environment for both study and relaxation.\n\nResidents enjoy modern amenities including a sparkling swimming pool, an energizing sport court, and 24-hour access to a dry sauna and free tanning. Nestled in the friendly neighborhood of Sunnydale in Des Moines, the community’s spacious living spaces are designed with comfort and style in mind. Maple Pointe ensures a perfect balance between accessibility to South Seattle College and a peaceful living environment, making it an ideal choice for those connected to the college.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Maple Pointe Near South Seattle College, King County",
      "seo_description": "Experience Maple Pointe, ideally located near South Seattle College in King County. Perfect for students and staff seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-near-valley-medical-center-des-moines-wa",
      "search_query": "apartments near Valley Medical Center Des Moines WA",
      "category": "Hospital",
      "h1_title": "Apartments Near Valley Medical Center, Des Moines",
      "h2_subtitle": "Discover Maple Pointe, offering apartments near Valley Medical Center in Des Moines, WA. Ideal for healthcare professionals and patients.",
      "page_copy": "Maple Pointe in Des Moines, WA, provides the perfect location for those looking for apartments near Valley Medical Center. Our community is situated conveniently for healthcare professionals, patients, or anyone needing quick access to medical services. Enjoy the balance of a peaceful residential environment with the convenience of living near a major healthcare facility.\n\nOur apartment community offers a range of amenities that make everyday life enjoyable and stress-free. Residents can take advantage of a refreshing swimming pool, a sport court for recreational play, and 24-hour access to a dry sauna and tanning services. Located in the welcoming Sunnydale neighborhood, Maple Pointe combines the benefits of suburban tranquility with easy access to essential services. Make Maple Pointe your home for a harmonious living experience near Valley Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Valley Medical Center, Des Moines, WA",
      "seo_description": "Find the perfect living space at Maple Pointe near Valley Medical Center in Des Moines, WA. Ideal location for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-close-to-st-anne-hospital-king-county",
      "search_query": "apartments close to St. Anne Hospital King County",
      "category": "Hospital",
      "h1_title": "Apartments Close to St. Anne Hospital",
      "h2_subtitle": "Explore Maple Pointe for modern apartments close to St. Anne Hospital in King County. Perfect for healthcare workers and patients needing nearby accommodation.",
      "page_copy": "At Maple Pointe in Des Moines, WA, find the perfect blend of comfort and convenience if you're seeking apartments close to St. Anne Hospital in King County. Our community is ideally suited for healthcare professionals, patients, and families who require easy access to medical care while enjoying the benefits of a serene living environment.\n\nMaple Pointe offers residents a wide range of amenities designed to elevate everyday living. Take a dip in our refreshing swimming pool, enjoy a game on the sport court, or relax in the 24-hour dry sauna. Located in the peaceful Sunnydale neighborhood, Maple Pointe ensures a quiet retreat while being just minutes away from St. Anne Hospital. Choose Maple Pointe for a thoughtful living experience near essential health services.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to St. Anne Hospital, King County",
      "seo_description": "Discover comfort at Maple Pointe, located close to St. Anne Hospital in King County. Ideal apartments for healthcare professionals and nearby patients.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-near-lincoln-park-des-moines-wa",
      "search_query": "apartments near Lincoln Park Des Moines WA",
      "category": "Park",
      "h1_title": "Apartments Near Lincoln Park, Des Moines",
      "h2_subtitle": "Discover Maple Pointe's charming apartments near Lincoln Park, Des Moines, WA. Enjoy nature and modern amenities just minutes away.",
      "page_copy": "Maple Pointe offers an idyllic setting for those seeking apartments near Lincoln Park in Des Moines, WA. Experience the perfect blend of natural beauty and modern living, ideal for outdoor enthusiasts who wish to have Lincoln Park's trails and scenery just a short distance away.\n\nOur community boasts amenities that add convenience and relaxation to everyday life. Unwind in our refreshing swimming pool, or stay active on the sport court. Residents also have 24-hour access to our dry sauna and tanning services, ensuring a perfect balance of recreation and leisure. Nestled in the scenic neighborhood of Sunnydale, Maple Pointe provides a tranquil living environment with easy access to the natural beauty of Lincoln Park, making it a top choice for nature lovers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lincoln Park, Des Moines, WA",
      "seo_description": "Explore Maple Pointe, offering ideal apartments near Lincoln Park in Des Moines, WA. Perfect for those who love nature and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "maple-pointe-apartments-near-seahurst-park",
      "search_query": "Maple Pointe apartments near Seahurst Park",
      "category": "Park",
      "h1_title": "Maple Pointe Apartments Near Seahurst Park",
      "h2_subtitle": "Explore the tranquility of Maple Pointe apartments near Seahurst Park. Perfectly situated for nature enthusiasts and those seeking serene living.",
      "page_copy": "Welcome to Maple Pointe, where comfort meets nature as our apartments are conveniently located near Seahurst Park. This prime location offers residents the best of both worlds with easy access to the natural splendor and stunning views at Seahurst Park, an ideal spot for hiking and picnics.\n\nMaple Pointe is more than just a place to live; it offers a vibrant community experience. Benefit from our on-property amenities including a swimming pool, a sport court, and 24-hour services like a dry sauna and tanning facilities. Set in the peaceful neighborhood of Sunnydale, our community provides an exceptional living environment that is a perfect getaway while still being close to all conveniences, especially Seahurst Park's beautiful outdoor spaces.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Maple Pointe Apartments Near Seahurst Park",
      "seo_description": "Discover Maple Pointe, ideally located near Seahurst Park. Enjoy serene living with beautiful nature and modern amenities at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "saltwater-state-park-nearby-apartments-sunnydale",
      "search_query": "Saltwater State Park nearby apartments Sunnydale",
      "category": "Park",
      "h1_title": "Sunnydale Apartments Near Saltwater State Park",
      "h2_subtitle": "Discover cozy apartments in Sunnydale near Saltwater State Park. Ideal for nature lovers seeking convenient access to outdoor adventures.",
      "page_copy": "Maple Pointe offers a perfect living option in the Sunnydale neighborhood for those in search of nearby apartments with quick access to Saltwater State Park. This location is ideal for individuals who appreciate nature and the outdoors, providing a perfect place to retreat after a day of exploring the park's beaches and trails.\n\nOur community not only offers proximity to beautiful outdoor spaces but also boasts exceptional amenities. Residents can enjoy a swimming pool, sport court, and conveniently accessible 24-hour dry sauna and free tanning services. Situated in a peaceful neighborhood, Maple Pointe in Sunnydale ensures you experience a tranquil living environment while having the stunning landscapes of Saltwater State Park just moments away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sunnydale Apartments Near Saltwater State Park",
      "seo_description": "Explore Maple Pointe in Sunnydale, offering nearby apartments to Saltwater State Park. Perfect for nature enthusiasts seeking modern comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "angle-lake-park-king-county-apartments",
      "search_query": "Angle Lake Park King County apartments",
      "category": "Park",
      "h1_title": "Apartments Near Angle Lake Park, King County",
      "h2_subtitle": "Live at Maple Pointe, offering King County apartments near the tranquil Angle Lake Park. Enjoy nature and community amenities in one location.",
      "page_copy": "Maple Pointe presents a unique opportunity for those seeking apartments near Angle Lake Park in King County. Nestled in the charming neighborhood of Sunnydale, our community provides residents with a serene atmosphere while offering close proximity to the picturesque Angle Lake Park, a popular destination for outdoor activities like picnicking and kayaking.\n\nAt Maple Pointe, comfort and convenience go hand in hand. Our residents enjoy access to fantastic amenities, including a swimming pool, sport court, and 24-hour facilities such as a dry sauna and free tanning services. With Angle Lake Park just a short drive away, you can embrace the natural beauty of King County without sacrificing modern living comforts. Discover your perfect home at Maple Pointe, where nature and community meet harmoniously.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Angle Lake Park, King County",
      "seo_description": "Maple Pointe offers King County apartments near Angle Lake Park. Ideal for those seeking modern living close to nature and recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-tacoma-airport",
      "search_query": "apartments near Seattle–Tacoma International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Seattle–Tacoma Int’l Airport",
      "h2_subtitle": "Find convenience at Maple Pointe apartments near Seattle–Tacoma International Airport. Perfect for frequent travelers seeking modern comforts.",
      "page_copy": "Maple Pointe is an ideal choice for those searching for apartments near Seattle–Tacoma International Airport. Located in the serene Sunnydale neighborhood, our community provides easy airport access for frequent travelers and professionals alike. With just a short drive, you can reach your flight on time while enjoying life away from the hustle and bustle.\n\nOur residents at Maple Pointe enjoy a variety of amenities designed for relaxation and convenience, such as a refreshing swimming pool, excellent sport court, and 24-hour services including a dry sauna and free tanning. Nestled in King County, our community offers a peaceful retreat with the added benefit of being near a major transport hub, making it the perfect balance of convenience and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle–Tacoma Int’l Airport",
      "seo_description": "Explore Maple Pointe, offering apartments near Seattle–Tacoma International Airport. Perfect for travelers seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "maple-pointe-close-to-tukwila-intl-blvd",
      "search_query": "Maple Pointe close to Tukwila Int'l Blvd",
      "category": "Transit",
      "h1_title": "Maple Pointe Near Tukwila Int’l Blvd",
      "h2_subtitle": "Discover Maple Pointe, ideally located near Tukwila Int'l Blvd. Enjoy easy access to shopping, dining, and transportation.",
      "page_copy": "Situated near Tukwila Int’l Blvd, Maple Pointe offers residents an unbeatable location in the heart of King County. This prime spot provides immediate access to vibrant shopping centers, diverse dining options, and efficient public transportation, making it perfect for those who value connectivity and convenience.\n\nApart from its strategic location, Maple Pointe boasts a range of amenities that cater to a relaxed and modern lifestyle. Residents can relish the use of a swimming pool, sport court, and 24-hour facilities such as free tanning and a dry sauna. With Tukwila Int'l Blvd just moments away, you can enjoy the dynamic urban lifestyle while retreating to the calm and comfort of the Sunnydale community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Maple Pointe Near Tukwila Int’l Blvd",
      "seo_description": "Discover Maple Pointe, close to Tukwila Int'l Blvd—offering access to shopping and transit, plus amenities like a pool, sport court, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "apartments-near-king-county-airport-boeing-field",
      "search_query": "apartments near King County International Airport - Boeing Field",
      "category": "Transit",
      "h1_title": "Apartments Near King County Airport",
      "h2_subtitle": "Explore apartments near King County International Airport - Boeing Field at Maple Pointe. Ideal for easy commutes and modern living.",
      "page_copy": "For those seeking apartments near King County International Airport - Boeing Field, Maple Pointe offers an outstanding living option in Des Moines, WA. Our location provides a convenient base for aviation professionals and frequent flyers, with seamless access to the airport facilities.\n\nMaple Pointe isn't just about location; it's about lifestyle, too. Our community features a variety of amenities including a swimming pool, sport court, and round-the-clock dry sauna and free tanning services. Enjoy the tranquility of the Sunnydale neighborhood while still being close to the action at Boeing Field. Maple Pointe ensures you have everything you need, from superb connectivity to relaxation facilities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near King County International Airport",
      "seo_description": "Find Maple Pointe apartments near King County International Airport - Boeing Field, offering amenities and convenience for aviation professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166897",
      "source": "generator",
      "page_item_url": "sunnydale-apartments-near-angle-lake-station",
      "search_query": "Sunnydale apartments near Angle Lake station",
      "category": "Transit",
      "h1_title": "Sunnydale Apartments by Angle Lake Station",
      "h2_subtitle": "Discover Sunnydale apartments near Angle Lake station at Maple Pointe. Ideal for commuters seeking comfort and convenience.",
      "page_copy": "Maple Pointe, nestled in the picturesque Sunnydale neighborhood, invites you to explore apartments near Angle Lake Station. This location is an excellent choice for commuters, offering swift and efficient transit options via the nearby light rail, making travel into downtown Seattle and surrounding areas a breeze.\n\nLife at Maple Pointe means enjoying top-tier amenities like a swimming pool, sport court, and 24-hour services including free tanning and a dry sauna. Our community provides a tranquil living environment while keeping you connected to the vibrant pulse of the city. With Angle Lake Station just a short walk away, Maple Pointe offers the perfect blend of comfort and accessibility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sunnydale Apartments by Angle Lake Station",
      "seo_description": "Explore Maple Pointe in Sunnydale, located near Angle Lake station. Perfect for commuters with amenities that offer relaxation and ease.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5947"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372412233"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-59S76W77"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-456-2574 "
    }
  ],
  "custom_qb_id": "5947",
  "custom_repli_id": "18372412233",
  "custom_google_gtm_id": "\tGTM-59S76W77",
  "custom_ppc_tracking_phone_number": "844-456-2574 "
};

export const generatedAt = '2026-09-23T19:56:08.471Z';
